import { useCallback, useEffect, useState } from 'react';
import './header.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import UserMenu from './user-menu';
import SideNav from './sidenav';
// import UserMenu from './user-menu';

function Header() {
    const state = useSelector((state: RootState) => state);
    const [showSideNav, setShowSideNav] = useState(true);
    const [sideNavOpen, setSideNavOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    return (
        <>
            <header>
                    {showSideNav && <i className={`fal ${sideNavOpen ? 'fa-times' : 'fa-bars'}`} onClick={()=> setSideNavOpen(!sideNavOpen)}></i>}
                    <img src={`${process.env.PUBLIC_URL}/img/logo.svg`} alt="Newsclip Logo" />
                    <h1> SENTENCE COLLECTOR </h1>
                    <i className="fal fa-user" onClick={() => setUserMenuOpen(!userMenuOpen)}></i>
                </header>
                <SideNav open={sideNavOpen} setOpen={setSideNavOpen}/>
                <UserMenu 
                    open={userMenuOpen}
                    setOpen={setUserMenuOpen}
                />
        </>
    )
}

export default Header;